export default "__VITE_ASSET__BTD4m4JT__"